export const COLLECTION_STATUS = {
    STOP: 'stop',
    BOOK: 'book',
    MINT_1: 'mint_1',
};
